/**
 * TGUARD Landing Page – Counter Animation + Scroll Reveal
 * Include this in your theme.liquid or via a script tag in a section.
 * No dependencies required.
 */
(function () {
  'use strict';

  /* ---- Scroll Reveal (lightweight AOS alternative) ---- */
  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-aos]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = parseInt(entry.target.getAttribute('data-aos-delay') || '0', 10);
            setTimeout(function () {
              entry.target.classList.add('aos-animate');
            }, delay);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Counter Animation ---- */
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCounter(el) {
    var endValue = parseInt(el.getAttribute('data-count-to') || '0', 10);
    var suffix = el.getAttribute('data-count-suffix') || '';
    var prefix = el.getAttribute('data-count-prefix') || '';
    var displayOverride = el.getAttribute('data-count-display') || '';
    var isDecimal = el.getAttribute('data-count-decimal') === 'true';
    var duration = 2000;

    // If display override exists, just show it (no animation)
    if (displayOverride) {
      el.textContent = displayOverride + suffix;
      return;
    }

    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = easeOutCubic(progress);
      var current = Math.floor(eased * endValue);

      if (isDecimal) {
        el.textContent = prefix + (current / 10).toFixed(1) + suffix;
      } else {
        el.textContent = prefix + current + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        if (isDecimal) {
          el.textContent = prefix + (endValue / 10).toFixed(1) + suffix;
        } else {
          el.textContent = prefix + endValue + suffix;
        }
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Animated Bar Fills ---- */
  function initBarAnimations() {
    var bars = document.querySelectorAll('[data-animate-width]');
    if (!bars.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var width = entry.target.getAttribute('data-animate-width');
            entry.target.style.width = width;
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    bars.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Init ---- */
  function init() {
    initScrollReveal();
    initCounters();
    initBarAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
